import { useEffect } from 'react'
import { Navigate, Routes } from 'react-router-dom'
import { useLogout } from '../../../hooks/queries/useAuth'

export function Logout() {
  const { mutate: logout } = useLogout()

  useEffect(() => {

    logout()
    // document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
